import React from 'react';
import PropTypes from 'prop-types';

import { snakeCase } from 'lodash';

import withMessages from 'component-utilities/intl';

import styles from '../ActionButtons.scss';
import STATUSES from '../Components/actionStatuses.json';
import { STATUS_NAMES } from './ActionsManager';

const BASE_KEY = 'components.buttons.action_buttons';

export default function ActionGenerator(type) {
    function ActionGeneratorComponent({ onClick, status, text, getMessage, children, ...restProps }) {
        const wrapperClass = `action-${type}${STATUSES[status]}`;

        return (
            <span
                data-action={`${type}-action`}
                data-field={`action-${type}`}
                data-status={status}
                className={styles[wrapperClass]}
                onClick={() => {
                    onClick(type);
                }}
                role="presentation"
                {...restProps}
            >
                {text || getMessage(`${BASE_KEY}.${snakeCase(type)}.text`)}
                {status === STATUS_NAMES.ACTIVE && children}
            </span>
        );
    }

    ActionGeneratorComponent.propTypes = {
        onClick: PropTypes.func.isRequired,
        status: PropTypes.oneOf(Object.keys(STATUSES)),
        text: PropTypes.string,
        getMessage: PropTypes.func.isRequired,
        children: PropTypes.any,
    };

    ActionGeneratorComponent.defaultProps = {
        status: 'NORMAL',
        text: null,
        children: null,
    };

    ActionGeneratorComponent.displayName = `ActionButton/${type}`;

    return withMessages(ActionGeneratorComponent);
}
